import React from 'react'

import { useEditor } from '@toasttab/sites-components'

import { ButtonType, CtaType } from 'src/apollo/sites'
import { t } from 'src/translations'

import { BrandedButton } from 'shared/components/common/button'
import Link from 'shared/components/common/link'

type PrimaryCTAProps = {
  onClick?: (event: React.SyntheticEvent) => void
  href?: string | null
  text: string
  iconRight?: React.ReactNode
  disabled?: boolean
  sameTab?: boolean
}

type EditablePrimaryCTAProps = {
  type: CtaType | 'customAction'
  editPath: string
} & PrimaryCTAProps

export const PrimaryCTAClasses = 'primaryCta'

export const EditablePrimaryCTA = (
  props: React.PropsWithChildren<EditablePrimaryCTAProps>
) => {
  const { useEditableRef } = useEditor()

  const { editableRef } = useEditableRef<HTMLDivElement>({
    name: 'primary cta',
    displayName: 'Button',
    actions: [],
    path: props.editPath,
    schema: { fields: [] }
  })

  return (
    <div ref={editableRef}>
      <PrimaryCTA {...props} />
    </div>
  )
}

const PrimaryCTA = ({ disabled = false, ...props }: PrimaryCTAProps) => {
  const ariaLabel = t('primary-cta.button-aria-label', {
    buttonText: props.text
  })
  const Wrapper = ({ children }: React.PropsWithChildren<{}>) =>
    props.href ? (
      <Link
        href={props.href}
        style={{ borderRadius: '10px' }}
        sameTab={props.sameTab}
        ariaLabel={ariaLabel}
      >
        {children}
      </Link>
    ) : (
      <>{children}</>
    )
  return (
    <Wrapper>
      <BrandedButton
        type='button'
        className={PrimaryCTAClasses}
        aria-hidden={!!props.href}
        tabIndex={props.href ? -1 : 0}
        variant={ButtonType.Primary}
        onClick={props.onClick}
        iconRight={props.iconRight}
        disabled={disabled}
        hasButtonRole={false}
        ariaLabel={!props.href ? ariaLabel : undefined}
        style={{ boxShadow: 'none' }}
      >
        {props.text}
      </BrandedButton>
    </Wrapper>
  )
}

export default PrimaryCTA
